import { FormControlLabel, Switch, Tooltip } from '@mui/material';

/**
 * Pojazdy archiwalne na listach floty (07.10.2026, prezentacja 02.10 pkt 14;
 * ClickUp 869fdgy42). Marathon: „za dużo” (610 aut razem z wycofanymi),
 * PM: „powinny być tylko auta w eksploatacji”.
 *
 * Archiwalny = oznaczony w TMS jako poza eksploatacją
 * (`vehicle_operational = false`, u nas `Car.operational`). Jawnego pola
 * „archiwum” TMS nie ma. Regułę liczy API (`cars/filters.ts`,
 * `IN_SERVICE_ALTERNATIVES`) — bez klucza `includeArchived` lista floty,
 * naczepy i harmonogram floty ich nie dostają. Ekran tylko przełącza klucz.
 *
 * Klucz filtra (`includeArchived`) react-admin zapamiętuje użytkownikom —
 * nie zmieniać nazwy.
 */
export const INCLUDE_ARCHIVED_FILTER = 'includeArchived';

export const INCLUDE_ARCHIVED_LABEL = 'Pokaż także archiwalne';

/** Dymek przy przełączniku — co znaczy „archiwalny”, bez zgadywania ponad dane. */
export const ARCHIVED_HINT =
  'Archiwalne to pojazdy oznaczone w TMS jako poza eksploatacją. Domyślnie ich nie pokazujemy.';

/** Przełącznik dla ekranów poza listą react-admina (harmonogram floty). */
export const ArchivedToggle = ({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange: (on: boolean) => void;
}) => (
  // `describeChild`: dymek opisuje przełącznik, nie zastępuje jego nazwy.
  <Tooltip describeChild title={ARCHIVED_HINT}>
    <FormControlLabel
      control={<Switch size="small" checked={checked} onChange={(e) => onChange(e.target.checked)} />}
      label={INCLUDE_ARCHIVED_LABEL}
    />
  </Tooltip>
);
